<template>
  <b-container fluid class="promotions">

     <!-- MODAL PROMO -->
    <b-modal
      header-bg-variant="note"
      size="lg"
      ref="promoModal"
      id="promoModal"
      centered
      :title="modalTitle"
      @ok="handleSave"
      cancel-title="Cancelar"
      :ok-title="okButtonText"
      :ok-disabled="disableEdition || haveErrors"
    >
      <b-form>
      <b-card header="Datos generales de la promoción">
        <b-alert :show="disableEdition" variant="warning">
          <b>Promoción gestionada por el administrador, los valores no se pueden modificar</b>
        </b-alert>
        <b-row>
          <b-col>
            <b-alert :show="errorText !== ''" fade variant="danger" v-html="errorText" dismissible>{{errorText}}</b-alert>
            <b-form-group
                id="nameInputGroup"
                :label-cols="2"
                breakpoint="md"
                :invalid-feedback="!promoStates.name? 'No es un valor válido' : ''"
                :state="promoStates.name"
                description="Nombre de la promoción"
                label="Nombre">
                <b-form-input
                  :disabled="disableEdition"
                  :state="promoStates.name"
                  v-model="promo.name"
                ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group
              id="activeInputGroup"
              :label-cols="2"
              breakpoint="md"
              label="¿La promoción esta activa?">
                <c-switch
                  inputType="checkbox"
                  type="text"
                  variant="success"
                  on="Si"
                  off="No"
                  :pill="true"
                  :disabled="disableEdition"
                  v-model="promo.isActive"
                  size="m"
                  id="s0"></c-switch>
              </b-form-group>
            </b-form-checkbox>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group
              id="descriptionGroup"
             :label-cols="2"
              breakpoint="md"
              label="Descripción"
              description="Descripción de la promoción"
              :invalid-feedback="!promoStates.description ? 'La descripción no es un texto válido' : ''"
              :state="promoStates.description"
              label-for="inputDescription">
              <b-form-textarea
                id="inputDescription"
                :disabled="disableEdition"
                v-model="promo.description"
                :state="promoStates.description"
                placeholder="Ingrese el texto de la descripción."
                :rows="3"
                :max-rows="6">
              </b-form-textarea>
            </b-form-group>
          </b-col>
        </b-row>
      </b-card>
      <b-card header="Validez de la promoción">
        <b-row>
          <b-col>
            <b-form-group
              id="dateFromGroup"
              breakpoint="md"
              label="Desde"
              :invalid-feedback="!promoStates.beginDate ? 'Fecha invalida' : ''"
              :state="promoStates.beginDate"
              label-for="fromDate">
              <date-picker
                :disabled="disableEdition"
                v-on:contextmenu.native.stop.prevent
                v-on:keydown.native.stop.prevent
                id="fromDate"
                :value="promo.beginDate"
                v-model="promo.beginDate"
                format="YYYY-MM-DD HH:mm:ss"
                valueType="YYYY-MM-DD HH:mm:ss"
                :clearable="true"
                :confirm="true"
                :lang="lang"
                type="datetime">
              </date-picker>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group
              id="dateToGroup"
              breakpoint="md"
              label="Hasta"
              :invalid-feedback="!promoStates.endDate ? 'Fecha invalida' : ''"
              :state="promoStates.endDate"
              label-for="toDate">
              <date-picker
                :disabled="disableEdition  || !promoStates.beginDate"
                v-on:contextmenu.native.stop.prevent
                v-on:keydown.native.stop.prevent
                id="toDate"
                v-model="promo.endDate"
                format="YYYY-MM-DD HH:mm:ss"
                valueType="YYYY-MM-DD HH:mm:ss"
                :clearable="true"
                :confirm="true"
                :lang="lang"
                type="datetime">
              </date-picker>
            </b-form-group>
          </b-col>
        </b-row>
      </b-card>
      <b-card header="Montos y tipo de descuento de la promoción">
        <b-row>
          <b-col>
            <b-form-group
                :label-cols="4"
                description="Defina el tipo de promoción, puede ser nominal o descuento"
                label="Seleccione el tipo de promoción"
              >
              <b-form-radio-group
                :disabled="disableEdition"
                @change="promoTypeChange"
                v-model="promo.promoType"
                :options="['Nominal', 'Porcentual']">
              </b-form-radio-group>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group
              id="promoValueInputGroup"
              :label-cols="2"
              breakpoint="md"
              :invalid-feedback="!promoStates.promoValue? 'No es un valor válido' : ''"
              :state="promoStates.promoValue"
              :description="promo.promoType === 'Nominal' ?  'Ingrese el valor exacto de descuento que se aplicara en la promoción' : 'Ingrese el valor porcentual de descuento que se aplicara en la promoción'"
              :label="promo.promoType === 'Nominal' ?  'Descuento exacto que se aplicara' : 'Descuento porcentual que se aplicara'">
              <b-form-input
                :disabled="disableEdition"
                @input="valuePromoChange"
                :state="promoStates.promoValue"
                v-model="promo.promoValue"
              ></b-form-input>
            </b-form-group>
            <hr>
            <p>Valor nominal: <b>{{currency}} {{promo.nominalDiscountValue}}</b></p>
            <p>Valor descuento: <b>{{promo.percentualDiscountValue}}%</b></p>
          </b-col>
        </b-row>
      </b-card>
      <b-card header="¿A qué elementos se aplica la promoción?">
        <p v-if="promo.sellers.length === 0 && promo.userType === 'ADMIN'">
          <b-alert show variant="warning">
            <b><i class="far fa-bell mr-2"></i>Promocion aplicada a todos los Sellers.</b>
          </b-alert>
        </p>
        <hr/>
        <b-row>
          <b-col class="mb-3">
            <b-form-group
              id="inputBrandGroup"
              :label-cols="2"
              breakpoint="md"
              label="Marcas a la cual aplica la promocion"
              label-for="inputBrand">
              <autocomplete
                id="inputBrand"
                name="inputBrand"
                :maxElements="100"
                :provider="getSearchBrands"
                :disabled="disableEdition"
                v-model="promo.brands">
              </autocomplete>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="mb-3">
            <b-form-group
               id="inputProductGroup"
              :label-cols="2"
              breakpoint="md"
              label="Productos a la cual aplica la promocion"
              label-for="inputProduct">
              <autocomplete
                id="inputProduct"
                name="inputProduct"
                :maxElements="100"
                :provider="getSearchProducts"
                :disabled="disableEdition"
                v-model="promo.products">
              </autocomplete>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group
               id="inputCategoriesGroup"
              :label-cols="2"
              breakpoint="md"
              label="Categorias a la cual aplica la promocion"
              label-for="inputCategories">
              <autocomplete
                id="inputCategories"
                name="inputCategories"
                :maxElements="100"
                :provider="getSearchCategories"
                :disabled="disableEdition"
                v-model="promo.categories">
              </autocomplete>
            </b-form-group>
          </b-col>
        </b-row>
        <!-- <b-row >
          <b-col>
            <b-form-group
               id="inputMarketGroup"
              :label-cols="2"
              breakpoint="md"
              label="Marketplaces a los cuales aplica la promocion"
              label-for="inputMarket">
              <autocomplete
                id="inputMarket"
                name="inputMarket"
                :maxElements="100"
                :searcheable="false"
                :provider="getSearchMarketplaces"
                :disabled="disableEdition"
                v-model="promo.marketplaces">
              </autocomplete>
            </b-form-group>
          </b-col>
        </b-row> -->
        <b-row v-if="isAdmin">
          <b-col>
            <b-form-group
               id="inputSellersGroup"
              :label-cols="2"
              breakpoint="md"
              label="Sellers a los cuales aplica la promocion"
              label-for="inputSellers">
              <autocomplete
                id="inputSellers"
                name="inputSellers"
                :maxElements="100"
                :provider="getSearchSeller"
                :disabled="disableEdition"
                v-model="promo.sellers">
              </autocomplete>
            </b-form-group>
          </b-col>
        </b-row>
      </b-card>
    </b-form>
    </b-modal>
    <!-- END MODAL PROMO -->

  </b-container>
</template>

<script>
// Mixims
import { ProductServiceMixim } from '@/mixims/ProductServiceMixim'
import { OrganizationService } from '@/mixims/AdminServiceMixin'
import { PromotionsServiceMixim } from '@/mixims/PromotionsServiceMixim'
// import { MarketplaceService } from '@/mixims/MarketplaceServiceMixim'
import { ValidationsMixim } from '@/mixims/ValidationsMixim'
import appConfig from '../../config/applicationConfig.js'
import autocomplete from '@/components/common/vue-autocomplete'
import 'vue2-datepicker/index.css'
import DatePicker from 'vue2-datepicker'
import cSwitch from '@/components/common/Switch'

export default {
  name: 'promo-details',
  mixins: [
    ProductServiceMixim,
    ValidationsMixim,
    OrganizationService,
    PromotionsServiceMixim
    // MarketplaceService
  ],
  components: {
    autocomplete,
    DatePicker,
    cSwitch
  },
  props: ['promo'],
  data () {
    return {
      lang: {
        formatLocale: {
          // MMMM
          months: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
          // MMM
          monthsShort: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
          // dddd
          weekdays: ['Domingo', 'Lunes', 'Martes', 'Miercoles', 'Jueves', 'Viernes', 'Sabado'],
          // ddd
          weekdaysShort: ['Dom', 'Lun', 'Mar', 'Mie', 'Jue', 'Vier', 'Sab'],
          // dd
          weekdaysMin: ['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sa']
        }
      },
      currency: appConfig.CURRENCY,
      locale: appConfig.LOCALE,
      isAdmin: this.$store.getters.isAdmin,
      modalTitle: '',
      okButtonText: 'Guardar',
      errorText: ''
    }
  },
  computed: {
    haveErrors () {
      return Object.values(this.promoStates).includes(false)
    },
    promoStates () {
      return {
        name: this.isValidText(this.promo.name, true, 25),
        description: this.isValidTextArea(this.promo.description, true),
        promoValue: this.isValidFloat(this.promo.promoValue, true, true),
        beginDate: this.validateDateBegin(this.promo.beginDate),
        endDate: this.validateDateEnd(this.promo.beginDate, this.promo.endDate)
      }
    },
    disableEdition () {
      if (this.promo.userType === 'ADMIN' && !this.isAdmin) {
        return true
      }
      return false
    }
  },
  methods: {
    validateDateBegin (dateBegin, mandatory = true) {
      if (!dateBegin) return !mandatory
      return true
    },
    validateDateEnd (dateBegin, dateEnd, mandatory = true) {
      if (!dateEnd) return !mandatory

      let dBegin = new Date(dateBegin)
      let dEnd = new Date(dateEnd)
      if (dEnd <= dBegin) {
        return false
      }
      return true
    },
    handleSave (evt) {
      evt.preventDefault()
      this.errorText = ''
      this.okButtonText = 'Espere...'

      if (this.promo.id) {
        this.processPromotion()
      } else {
        this.getPromotionByName(this.promo.name).then(
          (response) => {
            if (!this.hasSamePromoName(response.body)) {
              this.processPromotion()
            } else {
              document.getElementById('promoModal').scroll(0, 0)
              this.errorText = `Ya existe una promoción con el mismo nombre`
              this.okButtonText = 'Guardar'
            }
          },
          (error) => {
            this.loading = false
            this.errorText = error.body.message || 'Error obteniendo las promociones'
            return []
          }
        )
      }
    },
    processPromotion () {
      this.savePromotion(this.promo).then(
        () => {
          let successText = this.promo.id !== null ? 'La promoción fue modificada con exito' : 'La promoción fue creada con exito'
          this.$emit('done', { key: 'successText', value: successText })
          this.$refs.promoModal.hide()
          this.okButtonText = 'Guardar'
        },
        () => {
          let errorText = `Ocurrió un error el ${this.promo.id ? 'actualizar' : 'crear'} la promoción`
          this.$emit('done', { key: 'errorText', value: errorText })
          this.$refs.promoModal.hide()
          this.okButtonText = 'Guardar'
        }
      )
    },
    hasSamePromoName (names) {
      let hasSameName = false

      names.forEach((promo) => {
        if (promo.name === this.promo.name) { hasSameName = true }
      })

      return hasSameName
    },
    promoTypeChange (type) {
      if (type === 'Nominal') {
        this.promo.nominalDiscountValue = this.promo.promoValue
        this.promo.percentualDiscountValue = 0
      } else {
        this.promo.nominalDiscountValue = 0
        this.promo.percentualDiscountValue = this.promo.promoValue
      }
    },
    valuePromoChange (value) {
      if (this.promo.promoType === 'Nominal') {
        this.promo.nominalDiscountValue = value
        this.promo.percentualDiscountValue = 0
      } else {
        this.promo.nominalDiscountValue = 0
        this.promo.percentualDiscountValue = value
      }
    },
    showModal (item) {
      this.errorText = ''
      this.okButtonText = 'Guardar'
      if (this.promo.id) {
        this.modalTitle = 'Actualizar promoción'
      } else {
        this.modalTitle = 'Crear promoción'
      }
      this.$refs.promoModal.show()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/promotion/PromoDetails.vue